'use client';

import {
  createContext,
  PropsWithChildren,
  useContext,
  useState,
  useMemo,
} from 'react';

export type NavigationButton = 'solutions' | 'search' | 'login';

interface MobileNavigationContextData {
  isOpen: boolean;
  activeNav: NavigationButton | null;
  onOpenNavigation(activeNav: NavigationButton): void;
  onCloseNavigation(): void;
}

const MobileNavigationContext = createContext(
  {} as MobileNavigationContextData,
);

export type MobileNavigationProviderProps = PropsWithChildren;

export const MobileNavigationProvider = (
  props: MobileNavigationProviderProps,
) => {
  const { children } = props;

  const [activeNav, setActiveNav] = useState<NavigationButton | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const onCloseNav = () => {
    setActiveNav(null);
    setIsOpen(false);

    document.body.style.overflow = 'unset';
  };

  const onOpenNavigation = (_activeNav: NavigationButton) => {
    setActiveNav(_activeNav);
    setIsOpen(true);

    document.body.style.overflow = 'hidden';
  };

  const value = useMemo(() => {
    return {
      isOpen,
      activeNav,
      onOpenNavigation,
      onCloseNavigation: onCloseNav,
    };
  }, [isOpen, activeNav, onOpenNavigation, onCloseNav]);

  return (
    <MobileNavigationContext.Provider value={value}>
      {children}
    </MobileNavigationContext.Provider>
  );
};

export const useMobileNavigation = () => useContext(MobileNavigationContext);
